import React, {Component} from "react";
import Radium from 'radium';
import Translate from "../../../../../../../components/Translate";
import ButtonMessageEdit from "../../ButtonMessageEdit";
import TextMessageEdit from "../../TextMessageEdit";
import {
    getClientHardcodedMessages,
    getClientHardcodedMessageStatusData,
    updateHardcodedMessageStatus
} from "../../../../../../../services/company/api";

const styles = {
    statisticTableOngoings: {
        float: 'right', marginRight: '15px',
    }, chatWithOperatorInfo: {
        display: 'flex',
    }, headerDiv: {
        height: '60px', display: 'flex', fontSize: '16px', color: '#09183A', fontWeight: '600', cursor: 'pointer',
    }, header: {
        height: '60px',
        flexGrow: 1,
        textAlign: 'center',
        lineHeight: '60px',
        WebkitBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        MozBoxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
        boxShadow: '0px 0px 15px 0px rgba(24,62,153,0.2)',
    }, listWrapper: {
        maxHeight: '369px', overflow: ' hidden scroll', width: '49%', marginTop: '35px',
    },
};

class HardcodedMessagesBottomTab extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hardCodedMessages: {}, hardCodedMessagesStatusData: {}
        }
    }

    componentDidMount() {
        const {client} = this.props;
        getClientHardcodedMessages(client.id)
            .then((hardCodedMessages) => {
                this.setState({
                    loading: false, hardCodedMessages,
                });
            });
        getClientHardcodedMessageStatusData(client.id)
            .then((data) => {
                this.setState({
                    loading: false, hardCodedMessagesStatusData: data,
                });
            });
    }

    handleCheckboxChange = (type) => {
        const {hardCodedMessagesStatusData} = this.state;
        const {client} = this.props;

        const currentStatus = hardCodedMessagesStatusData[type] ? hardCodedMessagesStatusData[type] : false;

        updateHardcodedMessageStatus(client.id, type, !currentStatus).then(() => {
            this.setState((prevState) => ({
                hardCodedMessagesStatusData: {
                    ...prevState.hardCodedMessagesStatusData,
                    [type]: !currentStatus,
                },
            }));
        });
    };

    messageTypeRender(type, locale) {
        const {hardCodedMessages, config, client} = this.props;
        const {hardCodedMessagesStatusData} = this.state;

        if (config.hardCodedMessagesTypeButtons.includes(type)) {
            return <ButtonMessageEdit handleCheckboxChange={this.handleCheckboxChange} client={client} type={type}
                                      hardCodedMessagesStatusData={hardCodedMessagesStatusData}
                                      value={hardCodedMessages[type][locale]}
                                      updateMessage={this.props.updateHardCodedMessages(type, locale)}/>;
        }

        return <TextMessageEdit handleCheckboxChange={this.handleCheckboxChange} client={client} type={type}
                                hardCodedMessagesStatusData={hardCodedMessagesStatusData}
                                value={hardCodedMessages[type][locale]}
                                updateMessage={this.props.updateHardCodedMessages(type, locale)}/>;
    }

    render() {
        const {activeTabId, localeOption, config, client, features} = this.props;

        const {hardCodedMessagesTypes} = config;

        const hardCodedMessagesTextTypes = hardCodedMessagesTypes.filter((item) => {
            if (!item.includes('TEXT')) return false;

            if (item === 'CHOOSE_SKILL_TEXT' && !features.includes(config.features.SKILLS)) {
                return false;
            }

            if (item === 'BLOCKED_TEXT' && !features.includes(config.features.BLACK_LIST)) {
                return false;
            }

            if (item === 'REMINDER_TEXT' && !features.includes(config.features.REMINDERS_NO_AI)) {
                return false;
            }

            if (item === 'OUT_WORKING_HOURS_TEXT' && !features.includes(config.features.WORKING_HOURS)) {
                return false;
            }

            if (item === 'OUT_WORKING_HOURS_TEXT' && !features.includes(config.features.WORKING_HOURS)) {
                return false;
            }

            if (item === 'AI_ATTACHMENT_ANSWER_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_WELCOME_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_ERROR_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'AI_RATE_TEXT' && !features.includes(config.features.AI)) {
                return false;
            }

            if (item === 'DONT_KNOW_TEXT' && !features.includes(config.features.TEXT_ACTION_NO_AI)) {
                return false;
            }

            if (item === 'SESSION_EXPIRE_TEXT' && !features.includes(config.features.EXPIRATION_TIME)) {
                return false;
            }


            if ((client.type === config.companyTypeMap.scenario
                && item === 'AI_ERROR_TEXT')) {
                return false;
            }

            if ((client.type === config.companyTypeMap.scenario
                && item === 'RATE_AI_TEXT')) {
                return false;
            }

            if (client.type === config.companyTypeMap.scenario
                && item === 'AI_WELCOME_TEXT') {
                return false;
            }

            if (client.type === config.companyTypeMap.scenario
                && item === 'AI_ATTACHMENT_ANSWER_TEXT') {
                return false;
            }

            if (client.type === config.companyTypeMap.smart
                && (item === 'DONT_KNOW_TEXT' || item === 'CHOOSE_FOLLOWING_TEXT')) {
                return false;
            }

            return true;
        });

        const hardCodedMessagesButtonTypes = hardCodedMessagesTypes.filter((item) => {
            if (item.includes('TEXT')) return false;

            if (item === 'REMINDER_BUTTON' && !features.includes(config.features.REMINDERS_NO_AI)) {
                return false;
            }

            return true;
        });

        if (activeTabId === -1) {
            return (<div/>);
        } else {
            return (<div style={{marginTop: '-35px'}}>
                <div style={styles.chatWithOperatorInfo}>
                    <div style={[styles.listWrapper, {padding: '15px 40px 10px 50px', marginLeft: '5px',}]}>
                        <div style={styles.localeMessagesWrapper}>
                            <ul className="no-style-list">
                                {hardCodedMessagesTextTypes.map((type) => (
                                    <div key={type}>
                                        <p style={[styles.localeName, {color: "black"}]}>
                                            <Translate text={type}/>
                                        </p>
                                        <li style={{
                                            wordWrap: "break-word",
                                            marginTop: "6px",
                                            marginBottom: "6px"
                                        }}>
                                            {this.messageTypeRender(type, localeOption.value)}
                                        </li>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div style={[styles.listWrapper, {padding: '15px 40px 10px 50px', marginLeft: '8px',}]}>
                        <ul className="no-style-list">
                            {hardCodedMessagesButtonTypes.map((type) => (
                                <div key={type}>
                                    <p style={[styles.localeName, {color: "black"}]}>
                                        <Translate text={type}/>
                                    </p>
                                    <li style={{wordWrap: "break-word", marginTop: "6px", marginBottom: "6px"}}>
                                        {this.messageTypeRender(type, localeOption.value)}
                                    </li>
                                </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>)
        }
    }

}

export default Radium(HardcodedMessagesBottomTab);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/HardcodedMessagesBottomTab.jsx